import React from "react";
import { getSisenseToken } from "../../api/User/Auth/SisenseApi";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";

const Sisense = () => {
  const user = useSelector((state) => state.userDetails.value);
  const [sisenseUrl, setSisenseUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  let email;

  useEffect(() => {
    if (user?.UserRole === "Client") {
      email = user?.emailId;
    } else {
      email = user?.UD_emp_email;
    }
    GenerateToken();
  }, []);

  const GenerateToken = () => {
    getSisenseToken(email).then((res) => {
      setSisenseUrl(
        `https://hubinternational.sisense.com/jwt?jwt=${res.data.token}&embed=true`
      );
    });
  };

  return (
    <div className="card rounded-0 border-0 overflow-auto h-100 w-100 d-flex align-items-center justify-content-center">
      {isLoading ? (
        <>
          <Spinner />
          <iframe
            className="d-none"
            src={sisenseUrl}
            title="Sisense Dashboard"
            width="100%"
            height="100%"
            onLoad={() => setIsLoading(false)}
          />
        </>
      ) : (
        sisenseUrl && (
          <>
            <iframe
              src={`https://hubinternational.sisense.com/app/main?embed=true&r=true&l=true&h=${
                user?.UserRole !== "Admin" ? "false" : "true"
              }`}
              title="Sisense Dashboard"
              width="100%"
              height="100%"
            />
          </>
        )
      )}
    </div>
  );
};

export default Sisense;
